import React, { useCallback, useEffect, useState } from "react";
import "../../profile.css";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import { useNavigate } from "react-router-dom";

const ChallengeManagement = () => {
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchChallenges = useCallback(async () => {
    try {
      setLoading(true);

      const response = await service.get(
        endpoints.challenges.myInitiatedChallenges
      );


      let challengeList = [];

      if (Array.isArray(response)) {
        challengeList = response;
      } else if (Array.isArray(response?.data)) {
        challengeList = response.data;
      } else if (Array.isArray(response?.data?.data)) {
        challengeList = response.data.data;
      } else if (Array.isArray(response?.data?.items)) {
        challengeList = response.data.items;
      }

      setChallenges(challengeList);
    } catch (error) {
      console.error("Failed to fetch challenges:", error);
      setChallenges([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchChallenges();
  }, [fetchChallenges]);

  const getStatusClass = (status) => {
    switch (status) {
      case "COMPLETED":
        return "challengeManagement-status-completed";

      case "UPCOMING":
        return "challengeManagement-status-upcoming";

      case "INITIATED":
      case "STARTED":
      case "IN_PROGRESS":
      default:
        return "challengeManagement-status-progress";
    }
  };

  return (
    <div className="challengeManagement-container">
      <div className="challengeManagement-header">
        <h1>Challenge Management</h1>
      </div>

      {loading ? (
        <div className="challengeManagement-empty">
          Loading challenges...
        </div>
      ) : !Array.isArray(challenges) || challenges.length === 0 ? (
        <div className="challengeManagement-empty">
          No challenges found.
        </div>
      ) : (
        <div className="challengeManagement-grid">
          {challenges.map((challenge) => (
            <div
              key={ challenge.challengeId}
              className="challengeManagement-card"
               onClick={() =>
    navigate(
      `/challenge-management/${challenge.challengeId}`
    )
  }
            >
              <div
                className={`challengeManagement-status ${getStatusClass(
                  challenge.status
                )}`}
              >
                {challenge.status?.replaceAll("_", " ")}
              </div>

              <div className="challengeManagement-content">
                <h3>{challenge.challengeName}</h3>

                <p>
                  {challenge.shortDescription ||
                    "No description available."}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChallengeManagement;